// Lightweight, dependency-free confetti for gentle milestone moments.
export function celebrate() {
  if (typeof document === "undefined") return;
  if (!document.getElementById("isc-confetti-style")) {
    const s = document.createElement("style");
    s.id = "isc-confetti-style";
    s.textContent = "@keyframes isc-fall{to{transform:translateY(108vh) rotate(720deg);opacity:0}}";
    document.head.appendChild(s);
  }
  const colors = ["#C2836B", "#9F634E", "#C49A5A", "#667A66", "#EFE7DA"];
  const root = document.createElement("div");
  root.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden";
  document.body.appendChild(root);
  for (let i = 0; i < 90; i++) {
    const p = document.createElement("div");
    const size = 6 + Math.random() * 7;
    p.style.cssText =
      `position:absolute;top:-24px;left:${Math.random() * 100}vw;width:${size}px;height:${size * 0.6}px;` +
      `background:${colors[i % colors.length]};border-radius:2px;opacity:.92;` +
      `animation:isc-fall ${1700 + Math.random() * 1500}ms ${Math.random() * 350}ms cubic-bezier(.3,.6,.4,1) forwards`;
    root.appendChild(p);
  }
  setTimeout(() => root.remove(), 3800);
}
